import { Injectable, inject } from '@angular/core'
import { TitleStrategy, RouterStateSnapshot } from '@angular/router'
import { Title } from '@angular/platform-browser'
import { ConfigService } from './config.service'

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private title = inject(Title)
  private configService = inject(ConfigService)
  private appName = ''

  constructor() {
    super()
    this.configService.getConfig().subscribe(cfg => {
      if (cfg.project_name) this.appName = cfg.project_name
      this.updateFavicon(cfg.branding_profile)
    })
  }

  private updateFavicon(brandingProfile?: string): void {
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
    if (!link) return
    link.href = brandingProfile ? `/imgs/${brandingProfile}.svg` : 'favicon.ico'
  }

  updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot)
    if (pageTitle && this.appName) {
      this.title.setTitle(`${pageTitle} - ${this.appName}`)
    } else if (pageTitle) {
      this.title.setTitle(pageTitle)
    } else if (this.appName) {
      this.title.setTitle(this.appName)
    }
  }
}
